"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StandbyInputMode;
(function (StandbyInputMode) {
    StandbyInputMode[StandbyInputMode["Active"] = 0] = "Active";
    StandbyInputMode[StandbyInputMode["Inactive"] = 1] = "Inactive";
})(StandbyInputMode = exports.StandbyInputMode || (exports.StandbyInputMode = {}));
function createDefaultOptions() {
    var value = "";
    var onChange = null;
    return {
        standbyHtml: "",
        activeHtml: "<input type=\"text\" />",
        mode: StandbyInputMode.Inactive,
        onActivated: function (el) {
            var input = el;
            input.value = value;
            onChange = function () { return value = input.value; };
            input.addEventListener("change", onChange);
        },
        onDeactivated: function (el) {
            el.innerHTML = value;
            if (onChange) {
                el.removeEventListener("change", onChange);
            }
        }
    };
}
function defaultCompiler(html) {
    var template = document.createElement("div");
    template.innerHTML = html;
    return template;
}
var StandbyInput = (function () {
    function StandbyInput(options, compilerOptions) {
        this.options = Object.assign({}, createDefaultOptions(), options);
        this.compilerOptions = compilerOptions || {};
        this.compilerOptions.compile = this.compilerOptions.compile || defaultCompiler;
        this.compilerOptions.attach = this.compilerOptions.attach || (function (_) { return null; });
        this.compilerOptions.detach = this.compilerOptions.detach || (function (_) { return null; });
        this.mode = this.options.mode;
    }
    StandbyInput.prototype.attach = function () {
        var element = this.createElement();
        this.compilerOptions.attach(element);
        return element;
    };
    StandbyInput.prototype.detach = function () {
        if (this.standbyElement) {
            this.standbyElement.dispose();
            this.standbyElement.element.remove();
        }
        if (this.activeElement) {
            this.activeElement.dispose();
            this.standbyElement.element.remove();
        }
    };
    StandbyInput.prototype.changeMode = function (mode) {
        if (this.mode === mode) {
            return;
        }
        this.mode = mode;
        if (mode === StandbyInputMode.Inactive) {
            this.showStandbyInput();
        }
        else {
            this.showActiveInput();
        }
    };
    StandbyInput.prototype.getElement = function () {
        if (this.mode === StandbyInputMode.Active && this.activeElement) {
            return this.activeElement.element;
        }
        else if (this.mode === StandbyInputMode.Inactive && this.standbyElement) {
            return this.standbyElement.element;
        }
        return null;
    };
    StandbyInput.prototype.recompile = function () {
        this.detach();
        return this.attach();
    };
    StandbyInput.prototype.showActiveInput = function () {
        if (this.standbyElement) {
            this.standbyElement.element.style.display = "none";
        }
        if (this.activeElement) {
            this.activeElement.element.style.display = "";
            if (this.options.onActivated) {
                this.options.onActivated(this.activeElement.element);
            }
        }
        else {
            var element = this.createActiveElement();
            this.compilerOptions.attach(element);
            if (this.options.onActivated) {
                this.options.onActivated(element);
            }
        }
        this.focusActiveElement();
    };
    StandbyInput.prototype.focusActiveElement = function () {
        var args = { cancel: false };
        if (!this.activeElement || !this.activeElement.element) {
            return;
        }
        if (this.options.onFocusing) {
            this.options.onFocusing(this.activeElement.element, args);
        }
        if (!args.cancel) {
            this.activeElement.element.focus();
        }
    };
    StandbyInput.prototype.showStandbyInput = function () {
        if (this.activeElement) {
            this.activeElement.element.style.display = "none";
        }
        if (!this.standbyElement) {
            var element = this.createStandbyElement();
            this.compilerOptions.attach(element);
            if (this.options.onDeactivated) {
                this.options.onDeactivated(element);
            }
        }
        else {
            this.standbyElement.element.style.display = "";
            if (this.options.onDeactivated) {
                this.options.onDeactivated(this.standbyElement.element);
            }
        }
    };
    StandbyInput.prototype.createElement = function () {
        var element = this.mode === StandbyInputMode.Inactive
            ? this.createStandbyElement()
            : this.createActiveElement();
        return element;
    };
    StandbyInput.prototype.createStandbyElement = function () {
        var _this = this;
        var element = this.compilerOptions.compile(this.options.standbyHtml);
        var onFocus = function () {
            _this.handleActivation();
        };
        if (element && element.addEventListener) {
            element.addEventListener("focus", onFocus);
        }
        this.standbyElement = {
            element: element,
            dispose: function () {
                if (element && element.removeEventListener) {
                    element.removeEventListener("focus", onFocus);
                }
            }
        };
        if (element) {
            element.tabIndex = 0;
        }
        return element;
    };
    StandbyInput.prototype.createActiveElement = function () {
        var _this = this;
        var element = this.compilerOptions.compile(this.options.activeHtml);
        var onFocus = function () {
            var childInput = element.querySelector("input,select,textarea");
            if (childInput && childInput !== element) {
                childInput.focus();
            }
        };
        var onBlur = function (ev) {
            var blurTarget = ev.relatedTarget;
            if (element !== blurTarget && element.contains(blurTarget)) {
                return;
            }
            _this.handleDeactivation();
        };
        if (element && element.addEventListener) {
            element.addEventListener("focus", onFocus);
            element.addEventListener("blur", onBlur, true);
        }
        this.activeElement = {
            element: element,
            dispose: function () {
                if (element && element.removeEventListener) {
                    if (element.removeEventListener) {
                        element.removeEventListener("focus", onFocus);
                        element.removeEventListener("blur", onBlur);
                    }
                }
            }
        };
        if (element) {
            element.tabIndex = 0;
        }
        return element;
    };
    StandbyInput.prototype.handleActivation = function () {
        if (!this.shouldActivate()) {
            return;
        }
        this.changeMode(StandbyInputMode.Active);
    };
    StandbyInput.prototype.handleDeactivation = function () {
        if (!this.shouldDeactivate()) {
            return;
        }
        else if (this.options.mode === StandbyInputMode.Active) {
            return false;
        }
        this.changeMode(StandbyInputMode.Inactive);
    };
    StandbyInput.prototype.shouldActivate = function () {
        var element = this.getElement();
        if (!element)
            return true;
        var activatingEvent = { cancel: false };
        if (this.options.onActivating) {
            this.options.onActivating(element, activatingEvent);
        }
        return !activatingEvent.cancel;
    };
    StandbyInput.prototype.shouldDeactivate = function () {
        if (this.mode === StandbyInputMode.Inactive) {
            return false;
        }
        var element = this.getElement();
        if (!element)
            return true;
        var deactivatingEvent = { cancel: false };
        if (this.options.onDeactivating) {
            this.options.onDeactivating(element, deactivatingEvent);
        }
        return !deactivatingEvent.cancel;
    };
    return StandbyInput;
}());
exports.StandbyInput = StandbyInput;
